import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "col-12 py-2" }
const _hoisted_2 = { class: "w-100 mt-2" }
const _hoisted_3 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-member-id",
  for: "referral-member-id"
}, [
  /*#__PURE__*/_createTextVNode(" Member ID: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-name",
  for: "referral-group-name"
}, " Group Name: ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-id",
  for: "referral-group-id"
}, " Group ID: ", -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "referral-primary-relationship" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "row w-100 ps-3"
}
const _hoisted_16 = { class: "form-group col-5 col-lg-5 pe-lg-12" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-first-name",
  for: "referral-insured-first-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured First Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_18 = { class: "form-group col-2 col-lg-2 pe-lg-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-mi",
  for: "referral-insured-mi"
}, " Insured MI: ", -1 /* HOISTED */)
const _hoisted_20 = { class: "form-group col-5 col-lg-5 pe-lg-12 pe-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-last-name",
  for: "referral-insured-last-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured Last Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-employer-name",
  for: "referral-employer-name"
}, " Employer Name: ", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-deductable-amount",
  for: "referral-deductable-amount"
}, " Deductable Amount: ", -1 /* HOISTED */)
const _hoisted_26 = { class: "col-12 py-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Deductable Met")
  ])
], -1 /* HOISTED */)
const _hoisted_28 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_29 = { class: "form-check custom-radio pb-1 mt-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-primary-deductible-yes"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-check custom-radio pb-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-primary-deductible-no"
}, " No ", -1 /* HOISTED */)
const _hoisted_33 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-copay-amount",
  for: "referral-copay-amount"
}, " Copay Amount: ", -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-member-id",
  for: "referral-member-id"
}, [
  /*#__PURE__*/_createTextVNode(" Member ID: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_37 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-name",
  for: "referral-group-name"
}, " Group Name: ", -1 /* HOISTED */)
const _hoisted_39 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-id",
  for: "referral-group-id"
}, " Group ID: ", -1 /* HOISTED */)
const _hoisted_41 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "referral-primary-relationship" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  key: 0,
  class: "row w-100 ps-3"
}
const _hoisted_46 = { class: "form-group col-5 col-lg-5 pe-lg-12" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-first-name",
  for: "referral-insured-first-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured First Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = { class: "form-group col-2 col-lg-2 pe-lg-12" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-mi",
  for: "referral-insured-mi"
}, " Insured MI: ", -1 /* HOISTED */)
const _hoisted_50 = { class: "form-group col-5 col-lg-5 pe-lg-12 pe-0" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-last-name",
  for: "referral-insured-last-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured Last Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_52 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-employer-name",
  for: "referral-employer-name"
}, " Employer Name: ", -1 /* HOISTED */)
const _hoisted_54 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-deductable-amount",
  for: "referral-deductable-amount"
}, " Deductable Amount: ", -1 /* HOISTED */)
const _hoisted_56 = { class: "col-12 py-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Deductable Met")
  ])
], -1 /* HOISTED */)
const _hoisted_58 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_59 = { class: "form-check custom-radio pb-1 mt-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-secondary-deductible-yes"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_61 = { class: "form-check custom-radio pb-1" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-secondary-deductible-no"
}, " No ", -1 /* HOISTED */)
const _hoisted_63 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-copay-amount",
  for: "referral-copay-amount"
}, " Copay Amount: ", -1 /* HOISTED */)
const _hoisted_65 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-member-id",
  for: "referral-member-id"
}, [
  /*#__PURE__*/_createTextVNode(" Member ID: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_67 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-name",
  for: "referral-group-name"
}, " Group Name: ", -1 /* HOISTED */)
const _hoisted_69 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-group-id",
  for: "referral-group-id"
}, " Group ID: ", -1 /* HOISTED */)
const _hoisted_71 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { for: "referral-primary-relationship" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Option", -1 /* HOISTED */)
const _hoisted_74 = ["value"]
const _hoisted_75 = {
  key: 0,
  class: "row w-100 ps-3"
}
const _hoisted_76 = { class: "form-group col-5 col-lg-5 pe-lg-12" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-first-name",
  for: "referral-insured-first-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured First Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_78 = { class: "form-group col-2 col-lg-2 pe-lg-12" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-mi",
  for: "referral-insured-mi"
}, " Insured MI: ", -1 /* HOISTED */)
const _hoisted_80 = { class: "form-group col-5 col-lg-5 pe-lg-12 pe-0" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-insured-last-name",
  for: "referral-insured-last-name"
}, [
  /*#__PURE__*/_createTextVNode(" Insured Last Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_82 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-employer-name",
  for: "referral-employer-name"
}, " Employer Name: ", -1 /* HOISTED */)
const _hoisted_84 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-deductable-amount",
  for: "referral-deductable-amount"
}, " Deductable Amount: ", -1 /* HOISTED */)
const _hoisted_86 = { class: "col-12 py-2" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Deductable Met")
  ])
], -1 /* HOISTED */)
const _hoisted_88 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_89 = { class: "form-check custom-radio pb-1 mt-3" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-tertiary-deductible-yes"
}, " Yes ", -1 /* HOISTED */)
const _hoisted_91 = { class: "form-check custom-radio pb-1" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mb-2",
  for: "referral-tertiary-deductible-no"
}, " No ", -1 /* HOISTED */)
const _hoisted_93 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral-copay-amount",
  for: "referral-copay-amount"
}, " Copay Amount: ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, [
          _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.type) + " Medicaid", 1 /* TEXT */)
        ])
      ])
    ]),
    (_ctx.type == 'Primary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              id: "referral-member-id",
              name: "referral-member-id",
              class: _normalizeClass(`form-control ${
                    _ctx.v$.referral.Insurance.PrimaryHealthPlanId.$error || _ctx.errors.Insurance.includes('PrimaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`),
              maxlength: "50",
              type: "text",
              placeholder: "Enter Member ID",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Insurance.PrimaryHealthPlanId) = $event)),
              onBlurr: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.PrimaryHealthPlanId.$touch && _ctx.v$.referral.Insurance.PrimaryHealthPlanId.$touch(...args))),
              onChange: _cache[2] || (_cache[2] = (e)=>_ctx.handleAllInput('PrimaryHealthPlanId',e.target.value,'Insurance'))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.Insurance.PrimaryHealthPlanId]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-name",
              name: "referral-group-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group Name",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Insurance.PrimaryGroupName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.PrimaryGroupName]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-id",
              name: "referral-group-id",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group ID",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.Insurance.PrimaryGroupId) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.PrimaryGroupId]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(`form-select ${
                    _ctx.v$.referral.Insurance.PrimaryRelationship.$error || _ctx.errors.Insurance.includes('PrimaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`),
              name: "referral-primary-relationship",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Insurance.PrimaryRelationship) = $event)),
              onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.PrimaryRelationship.$touch && _ctx.v$.referral.Insurance.PrimaryRelationship.$touch(...args))),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleAllInput('PrimaryRelationship', _ctx.referral.Insurance.PrimaryRelationship, 'Insurance')))
            }, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options?.primaryRelationship, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.value,
                  value: status.value
                }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_14))
              }), 128 /* KEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.Insurance.PrimaryRelationship]
            ])
          ]),
          (_ctx.referral.Insurance.PrimaryRelationship != '2' && _ctx.referral.Insurance.PrimaryRelationship != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-first-name",
                    name: "referral-insured-first-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName.$error ||
                        _ctx.errors.PrimaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured First Name",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName) = $event)),
                    onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName.$touch(...args))),
                    onChange: _cache[10] || (_cache[10] = (e)=>_ctx.handleAllInput('FirstName', e.target.value, 'PrimaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.FirstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-mi",
                    name: "referral-insured-mi",
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter Insured MI",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.MiddleInitial) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.MiddleInitial]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-last-name",
                    name: "referral-insured-last-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName.$error ||
                        _ctx.errors.PrimaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured Last Name",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName) = $event)),
                    onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName.$touch(...args))),
                    onChange: _cache[14] || (_cache[14] = (e)=>_ctx.handleAllInput('LastName', e.target.value, 'PrimaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.LastName]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("input", {
              id: "referral-employer-name",
              name: "referral-employer-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Name",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.EmployerName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.EmployerName]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              id: "referral-deductable-amount",
              name: "referral-deductable-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleAmount]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  id: "referral-primary-deductible-yes",
                  name: "referral-primary-deductible-yes",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet) = $event)),
                  value: "1"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  name: "referral-primary-deductible-no",
                  id: "referral-primary-deductible-no",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet) = $event)),
                  value: "0"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_32
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createElementVNode("input", {
              id: "referral-copay-amount",
              name: "referral-copay-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.CopayAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PrimaryInsuredDetails.CopayAmount]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.type == 'Secondary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _withDirectives(_createElementVNode("input", {
              id: "referral-member-id",
              name: "referral-member-id",
              class: _normalizeClass(`form-control ${
                    _ctx.v$.referral.Insurance.SecondaryHealthPlanId.$error ||
                    _ctx.errors.Insurance.includes('SecondaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`),
              maxlength: "50",
              type: "text",
              placeholder: "Enter Member ID",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.referral.Insurance.SecondaryHealthPlanId) = $event)),
              onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.SecondaryHealthPlanId.$touch && _ctx.v$.referral.Insurance.SecondaryHealthPlanId.$touch(...args))),
              onChange: _cache[22] || (_cache[22] = (e)=>_ctx.handleAllInput('SecondaryHealthPlanId', e.target.value, 'Insurance'))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.Insurance.SecondaryHealthPlanId]
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-name",
              name: "referral-group-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group Name",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.referral.Insurance.SecondaryGroupName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.SecondaryGroupName]
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-id",
              name: "referral-group-id",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group ID",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.referral.Insurance.SecondaryGroupId) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.SecondaryGroupId]
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(`form-select ${
                    _ctx.v$.referral.Insurance.SecondaryRelationship.$error ||
                    _ctx.errors.Insurance.includes('SecondaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`),
              name: "referral-primary-relationship",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.referral.Insurance.SecondaryRelationship) = $event)),
              onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.SecondaryRelationship.$touch && _ctx.v$.referral.Insurance.SecondaryRelationship.$touch(...args))),
              onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleAllInput('SecondaryRelationship', _ctx.referral.Insurance.SecondaryRelationship, 'Insurance')))
            }, [
              _hoisted_43,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options?.secondaryRelationship, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.value,
                  value: status.value
                }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_44))
              }), 128 /* KEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.Insurance.SecondaryRelationship]
            ])
          ]),
          (_ctx.referral.Insurance.SecondaryRelationship != '2' && _ctx.referral.Insurance.SecondaryRelationship != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-first-name",
                    name: "referral-insured-first-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName.$error ||
                        _ctx.errors.SecondaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured First Name",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName) = $event)),
                    onBlur: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName.$touch(...args))),
                    onChange: _cache[30] || (_cache[30] = (e)=>_ctx.handleAllInput('FirstName', e.target.value, 'SecondaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.FirstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-mi",
                    name: "referral-insured-mi",
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter Insured MI",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.MiddleInitial) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.MiddleInitial]
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-last-name",
                    name: "referral-insured-last-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName.$error ||
                        _ctx.errors.SecondaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured Last Name",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName) = $event)),
                    onBlur: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName.$touch(...args))),
                    onChange: _cache[34] || (_cache[34] = (e)=>_ctx.handleAllInput('LastName', e.target.value, 'SecondaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.LastName]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _withDirectives(_createElementVNode("input", {
              id: "referral-employer-name",
              name: "referral-employer-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Name",
              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.EmployerName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.EmployerName]
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _withDirectives(_createElementVNode("input", {
              id: "referral-deductable-amount",
              name: "referral-deductable-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleAmount]
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  id: "referral-secondary-deductible-yes",
                  name: "referral-secondary-deductible-yes",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet) = $event)),
                  value: "1"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_60
              ]),
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  name: "referral-secondary-deductible-no",
                  id: "referral-secondary-deductible-no",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet) = $event)),
                  value: "0"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_62
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _withDirectives(_createElementVNode("input", {
              id: "referral-copay-amount",
              name: "referral-copay-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.CopayAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.SecondaryInsuredDetails.CopayAmount]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_ctx.type == 'Tertiary')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _withDirectives(_createElementVNode("input", {
              id: "referral-member-id",
              name: "referral-member-id",
              class: _normalizeClass(`form-control ${
                    _ctx.v$.referral.Insurance.TertiaryHealthPlanId.$error ||
                    _ctx.errors.Insurance.includes('TertiaryHealthPlanId')
                        ? 'border border-warning'
                        : ''
                }`),
              maxlength: "50",
              type: "text",
              placeholder: "Enter Member ID",
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.referral.Insurance.TertiaryHealthPlanId) = $event)),
              onBlur: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.TertiaryHealthPlanId.$touch && _ctx.v$.referral.Insurance.TertiaryHealthPlanId.$touch(...args))),
              onChange: _cache[42] || (_cache[42] = (e)=>_ctx.handleAllInput('TertiaryHealthPlanId', e.target.value, 'Insurance'))
            }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelText, _ctx.referral.Insurance.TertiaryHealthPlanId]
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-name",
              name: "referral-group-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group Name",
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.referral.Insurance.TertiaryGroupName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.TertiaryGroupName]
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _withDirectives(_createElementVNode("input", {
              id: "referral-group-id",
              name: "referral-group-id",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Group ID",
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.referral.Insurance.TertiaryGroupId) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.TertiaryGroupId]
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(`form-select ${
                    _ctx.v$.referral.Insurance.TertiaryRelationship.$error ||
                    _ctx.errors.Insurance.includes('TertiaryRelationship')
                        ? 'border border-warning'
                        : ''
                }`),
              name: "referral-primary-relationship",
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.referral.Insurance.TertiaryRelationship) = $event)),
              onBlur: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.TertiaryRelationship.$touch && _ctx.v$.referral.Insurance.TertiaryRelationship.$touch(...args))),
              onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.handleAllInput('TertiaryRelationship', _ctx.referral.Insurance.TertiaryRelationship, 'Insurance')))
            }, [
              _hoisted_73,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options?.tertiaryRelationship, (status) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: status.value,
                  value: status.value
                }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_74))
              }), 128 /* KEYED_FRAGMENT */))
            ], 34 /* CLASS, HYDRATE_EVENTS */), [
              [_vModelSelect, _ctx.referral.Insurance.TertiaryRelationship]
            ])
          ]),
          (_ctx.referral.Insurance.TertiaryRelationship != '2' && _ctx.referral.Insurance.TertiaryRelationship != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-first-name",
                    name: "referral-insured-first-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName.$error ||
                        _ctx.errors.TertiaryInsuredDetails.includes('FirstName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured First Name",
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName) = $event)),
                    onBlur: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName.$touch(...args))),
                    onChange: _cache[50] || (_cache[50] = (e)=>_ctx.handleAllInput('FirstName',e.target.value, 'TertiaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.FirstName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-mi",
                    name: "referral-insured-mi",
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter Insured MI",
                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.MiddleInitial) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.MiddleInitial]
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _hoisted_81,
                  _withDirectives(_createElementVNode("input", {
                    id: "referral-insured-last-name",
                    name: "referral-insured-last-name",
                    class: _normalizeClass(`form-control ${
                        _ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName.$error ||
                        _ctx.errors.TertiaryInsuredDetails.includes('LastName')
                            ? 'border border-warning'
                            : ''
                    }`),
                    maxlength: "50",
                    type: "text",
                    placeholder: "Enter Insured Last Name",
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName) = $event)),
                    onBlur: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName.$touch(...args))),
                    onChange: _cache[54] || (_cache[54] = (e)=>_ctx.handleAllInput('LastName',e.target.value, 'TertiaryInsuredDetails'))
                  }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                    [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.LastName]
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _withDirectives(_createElementVNode("input", {
              id: "referral-employer-name",
              name: "referral-employer-name",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Name",
              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.EmployerName) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.EmployerName]
            ])
          ]),
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _withDirectives(_createElementVNode("input", {
              id: "referral-deductable-amount",
              name: "referral-deductable-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleAmount]
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  id: "referral-tertiary-deductible-yes",
                  name: "referral-tertiary-deductible-yes",
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet) = $event)),
                  value: "1"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_90
              ]),
              _createElementVNode("div", _hoisted_91, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  id: "referral-tertiary-deductible-no",
                  name: "referral-tertiary-deductible-no",
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet) = $event)),
                  value: "0"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.DeductibleMet]
                ]),
                _hoisted_92
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _withDirectives(_createElementVNode("input", {
              id: "referral-copay-amount",
              name: "referral-copay-amount",
              class: "form-control",
              maxlength: "50",
              type: "text",
              placeholder: "Enter Amount",
              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.CopayAmount) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.TertiaryInsuredDetails.CopayAmount]
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}